import {
  ChangeDetectorRef,
  Component,
  NgZone,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { CommercialInvoiceComponent } from '../commercial-invoice/commercial-invoice.component';
import { CommonModule } from '@angular/common';
import { AirWaybillGenerationPreviewComponent } from '../air-waybill-generation-preview/air-waybill-generation-preview.component';
import { AIRWAY_BILL_PRINT_MESSAGE } from '../../utility/constants';

@Component({
  selector: 'app-airway-bill-print',
  standalone: true,
  imports: [
    CommonModule,
    CommercialInvoiceComponent,
    AirWaybillGenerationPreviewComponent,
  ],
  templateUrl: './airway-bill-print.component.html',
  styleUrl: './airway-bill-print.component.scss',
})
export class AirwayBillPrintComponent implements OnInit, OnDestroy {
  public printData: any;

  private readonly messageHandler = (event: MessageEvent) => {
    if (event.origin !== window.location.origin) return;

    if (event.data?.type === AIRWAY_BILL_PRINT_MESSAGE.PING) {
      this.notifyReady();
      return;
    }

    if (event.data?.type === AIRWAY_BILL_PRINT_MESSAGE.READY) return;
    if (!event.data?.isFrom) return;

    this.ngZone.run(() => {
      this.printData = event.data;
      this.changeDetectorRef.detectChanges();
      this.schedulePrint();
    });
  };

  private readonly afterPrintHandler = () => {
    window.close();
  };

  private printTimer?: number;

  constructor(
    private readonly ngZone: NgZone,
    private readonly changeDetectorRef: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    window.addEventListener('message', this.messageHandler);
    window.onafterprint = this.afterPrintHandler;
    this.notifyReady();
  }

  ngOnDestroy(): void {
    window.removeEventListener('message', this.messageHandler);
    window.onafterprint = null;
    if (this.printTimer) {
      clearTimeout(this.printTimer);
    }
  }

  private notifyReady(): void {
    window.opener?.postMessage(
      { type: AIRWAY_BILL_PRINT_MESSAGE.READY },
      window.location.origin
    );
  }

  private schedulePrint(): void {
    if (this.printTimer) {
      clearTimeout(this.printTimer);
    }

    // Wait for *ngIf child + AfterViewInit barcode setTimeout(0), then two frames for paint
    this.printTimer = window.setTimeout(() => {
      const printWhenPainted = () => {
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            window.print();
          });
        });
      };

      if (document.fonts?.ready) {
        void document.fonts.ready.then(printWhenPainted);
      } else {
        printWhenPainted();
      }
    }, 0);
  }
}
